import { CompetitionsMenuSchema } from '@/views/sports/components/CompetitionsMenu/styles/CompetitionsMenu.styles';

export const competitionsMenuStyles: CompetitionsMenuSchema = {
  accordion: {
    color: 'alpha.800',
    minW: '190px',
    mr: '3',
    height: 'fit-content',
    boxShadow: 'md',
    borderRadius: 'md',
    overflow: 'hidden',
  },
  accordionItem: {
    outline: 'none',
    border: 'none',
    mt: '1px',
  },
  accordionButton: {
    pl: '3',
    pr: '2',
    bgGradient: 'linear(to-b, #5F6ABF, #495192)',

    // borderBottomWidth: '1px',
    // borderBottomColor: 'alpha.800',
    // borderTopWidth: '1px',
    // borderTopColor: 'alpha.400',
    _hover: { bgGradient: 'linear(to-b, #5F6ABF, #495192)' },
  },
  accordionHeadingText: {
    flex: '1',
    fontSize: 'sm',
    textAlign: 'left',
    fontWeight: 'bold',
    color: 'white',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  accordionIcon: {
    color: 'white',
  },
  accordionPanel: {
    p: '0',
    fontSize: 'xs',
    bg: 'beta.600',
    color: 'white',
    fontWeight: 'medium',

    _last: {
      border: 'none',
    },
  },
};
